__turbopack_context__.v({
  "ampersand": "VoltageTypeSwitch-module-scss-module__A5GR8a__ampersand",
  "voltageTypeButton": "VoltageTypeSwitch-module-scss-module__A5GR8a__voltageTypeButton",
  "voltageTypeSwitch": "VoltageTypeSwitch-module-scss-module__A5GR8a__voltageTypeSwitch",
});
